import { render, staticRenderFns } from "./link-btn-wrap.vue?vue&type=template&id=4e70335f&scoped=true"
import script from "./link-btn-wrap.vue?vue&type=script&lang=js"
export * from "./link-btn-wrap.vue?vue&type=script&lang=js"
import style0 from "./link-btn-wrap.vue?vue&type=style&index=0&id=4e70335f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e70335f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default})
